var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"primary-color small text-right mt-3"},[_c('router-link',{attrs:{"to":"/login"}},[_vm._v("Have an account? Login")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }